/**
 * Base SVG wrapper for the bespoke thin-stroke icon set. 24px grid, 1.5px
 * stroke, squared terminals, drawn in `currentColor` so icons inherit text
 * color. Decorative by default (`aria-hidden`).
 */
import type { CSSProperties, ReactNode } from "react";

export type IconProps = {
  /** Rendered square size in px. */
  size?: number;
  style?: CSSProperties;
  className?: string;
};

type IconBaseProps = IconProps & {
  children: ReactNode;
  /** Set for filled glyphs (brand logos); stroke icons leave it off. */
  filled?: boolean;
};

export function IconBase({
  size = 24,
  style,
  className,
  filled = false,
  children,
}: IconBaseProps) {
  return (
    <svg
      aria-hidden
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={filled ? undefined : 1.5}
      strokeLinecap="square"
      strokeLinejoin="miter"
      style={style}
      className={className}
    >
      {children}
    </svg>
  );
}
